import { call, get } from 'vuex-pathify';
export default {
  computed: {
    configurationList: get('sendMessage/configurationList'),
    isSendMessageSettingsEnabled: get('admin/settingsValues@send_message_module_enabled'),
    isSendMessageModuleEnabled: get('admin/additionalModules@SEND_MESSAGE_MODULE.enabled'),
    isSendEmailSmsConfigurationEnabled: get('admin/settingsValues@send_message_templates_superadmin_enabled'),
    hasSendMessagePermissions() {
      return this.$store.get('users/toolsPermissions')['SEND_MESSAGE_MODULE'].main_value > 0;
    },
    sendMessageLayers() {
      return this.configurationList.filter(layer => layer.layer === this.layerId);
    },
    isSendMessageVisible() {
      return this.isSendMessageSettingsEnabled && this.isSendMessageModuleEnabled && this.hasSendMessagePermissions;
    },
    sendMessageButton() {
      return this.isSendMessageVisible && (!this.isSendEmailSmsConfigurationEnabled || !!this.sendMessageLayers.length)
        ? [
            {
              name: 'sendMessage',
              icon: 'mdi-email',
              tooltip: this.isAnyFeatureSelected
                ? this.$i18n.t('button.sendMessage')
                : this.$i18n.t('button.toSendMessage', {
                    suffix: this.$i18n.t('button.atLeastOneSelected'),
                  }),
              fontSize: '19px',
              disabled: !this.isAnyFeatureSelected,
            },
          ]
        : [];
    },
    watermetersLayerId() {
      return this.$_objectToArray(this.layers).find(layer => layer.role === 'water_watermeters')?.id || null;
    },
    isWatermetersLayer() {
      return this.currentLayer?.id === this.watermetersLayerId;
    },
    billingSmsSendingEnabled: get('admin/settingsValues@billing_sms_sending_enabled'),
    isBillingSendMessageVisible() {
      return this.billingSmsSendingEnabled && this.isWatermetersLayer;
    },
    sendBillingMessageButton() {
      return this.isBillingSendMessageVisible
        ? [
            {
              name: 'sendBillingMessage',
              icon: 'mdi-cellphone-message',
              tooltip: this.isAnyFeatureSelected
                ? this.$i18n.t('button.sendSms')
                : this.$i18n.t('button.toSendSms', {
                    suffix: this.$i18n.t('button.atLeastOneSelected'),
                  }),
              fontSize: '20px',
              disabled: !this.isAnyFeatureSelected,
            },
          ]
        : [];
    },
  },
  data: () => ({
    isSendMessageDialogVisible: false,
    isSendMessageDialogLoaded: false,
    isSendBillingMessageDialogVisible: false,
    isSendBillingMessageDialogLoaded: false,
  }),
  mounted() {
    this.getSendMessageLayers();
  },
  methods: {
    getConfigurationList: call('sendMessage/getConfigurationList'),
    async getSendMessageLayers() {
      if (this.isSendMessageVisible && !this.configurationList.length && this.isSendEmailSmsConfigurationEnabled)
        await this.getConfigurationList();
    },
    sendMessageAction() {
      this.isSendMessageDialogLoaded = true;
      this.isSendMessageDialogVisible = true;
    },
    sendBillingMessageAction() {
      this.isSendBillingMessageDialogLoaded = true;
      this.isSendBillingMessageDialogVisible = true;
    },
  },
};
